import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./setupAxios";
import { useAuth } from "./context/authContext";
import { INICIO, msgError } from "./utils";
import Logo from "./components/Logo";

export default function Login() {
  const [usuario, setUsuario] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const enviar = async (e) => {
    e.preventDefault();
    setError("");
    setCargando(true);
    try {
      const { data } = await api.post("/login", { usuario, password });
      if (!data.ok) {
        setError(data.error || "No se pudo iniciar sesión");
        setCargando(false);
        return;
      }
      login({ user: data.user, access_token: data.access_token, refresh_token: data.refresh_token });
      nav(INICIO[data.user.tipo] || "/", { replace: true });
    } catch (err) {
      setError(msgError(err, "Usuario o clave incorrectos"));
      setCargando(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="card login-card" onSubmit={enviar}>
        <Logo className="login-logo" titulo="Check-in Campus Home" />
        <h2 style={{ textAlign: "center" }}>Check-in Campus Home</h2>
        {error && <div className="alert alert-error">{error}</div>}
        <label>Usuario o correo</label>
        <input type="text" value={usuario} onChange={(e) => setUsuario(e.target.value)} autoFocus required autoComplete="username"
               autoCapitalize="none" autoCorrect="off" spellCheck={false} />
        <label>Clave</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password"
               inputMode="text" />
        <button type="submit" className="btn btn-primary" style={{ width: "100%", marginTop: 16 }} disabled={cargando}>
          {cargando ? "Entrando…" : "Entrar"}
        </button>
        <p className="muted" style={{ textAlign: "center", marginBottom: 0 }}>
          Alumnos: tu correo y la clave que te hemos enviado.
        </p>
      </form>
    </div>
  );
}
